/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Judy_AdamsInputs */

const en_testimonial_judy_adams = /** @type {(inputs: Testimonial_Judy_AdamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is the best TTS service I've used so far. It's a huge help as a visually-impaired student. Thank you for making this!`)
};

const es_testimonial_judy_adams = /** @type {(inputs: Testimonial_Judy_AdamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este es el mejor servicio de TTS que he usado hasta ahora. Es una gran ayuda como estudiante con discapacidad visual. ¡Gracias por crear esto!`)
};

/**
* | output |
* | --- |
* | "This is the best TTS service I've used so far. It's a huge help as a visually-impaired student. Thank you for making this!" |
*
* @param {Testimonial_Judy_AdamsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_judy_adams = /** @type {((inputs?: Testimonial_Judy_AdamsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Judy_AdamsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_judy_adams(inputs)
	return en_testimonial_judy_adams(inputs)
});